// This uses a common dialog target in the footer

// To use add an action to call open and a href data attribute.
// When clicked, the href is fetch and inserted into the common dialog and its shown as a modal.
// eg. a.primary data-action="click->dialog#open" data-href="/admin/images"

// You can also open and close with events dialog:open (url in details), dialog:close

import { Controller } from "@hotwired/stimulus";
// import { fire } from "utils/events";

export default class extends Controller {
  static targets = [
    "dialog"
  ];

  initialize() {
    this.onOpenBind = this.onOpen.bind(this);
    this.onCloseBind = this.onClose.bind(this);
  }

  connect() {
    document.addEventListener("dialog:open", this.onOpenBind);
    document.addEventListener("dialog:close", this.onCloseBind);

    if (!this.hasDialogTarget) {
      // console.error('Dialog is missing dialog target');
      this.lazyCreateDialog(); // skip error, just inject one into the footer
    }

    // if turbo navigating back to a page where the dialog was open, close it
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close();
    }
  }

  disconnect() {
    document.removeEventListener("dialog:open", this.onOpenBind);
    document.removeEventListener("dialog:close", this.onCloseBind);
  }

  onOpen(event) {
    this.fetchAndOpen(event.detail.url);
  }

  onClose() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close();
    }
  }

  lazyCreateDialog() {
    const dialog_el = document.createElement("dialog");
    dialog_el.setAttribute("data-dialog-target", "dialog");
    this.element.appendChild(dialog_el);
  }

  open(event) {
    event.preventDefault();
    // grab the url from data attributes
    // using this instead of values as the same dialog target is shared with all launch buttons
    const url = event.currentTarget.dataset.href;
    this.fetchAndOpen(url);
  }

  fetchAndOpen(url) {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          const error = new Error(`HTTP error ${response.status}: ${response.statusText}`);
          error.status = response.status;
          error.url = url;
          throw error;
        }
        return response.text();
      })
      .then(html => {
        this.dialogTarget.innerHTML = html;
        this.dialogTarget.showModal();
        // fire(this.dialogTarget, 'dialog:shown'); // for if we ever need this
      })
      .catch(error => {
        console.error("Dialog fetch failed:", {
          url: url,
          error: error.message,
          status: error.status
        });
        alert("Could not load content. Please try again.");
      });
  }

  close() {
    this.dialogTarget.close();
    // fire(this.dialogTarget, 'dialog:closed'); // for if we ever need this
  }
}
